export enum EFontSize {
  MICRO = 8,
  EXTRA_TINY = 10,
  TINY = 12,
  SMALL = 14,
  NORMAL = 16,
  LARGE = 18,
}

export const DEFAULT_FONT_SIZE: EFontSize = EFontSize.SMALL;

export const SUPPORTED_FONT_SIZES: EFontSize[] = [
  EFontSize.MICRO,
  EFontSize.EXTRA_TINY,
  EFontSize.TINY,
  EFontSize.SMALL,
  EFontSize.NORMAL,
  EFontSize.LARGE,
];
